package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.{CCABServer, CreateAccountData, IdentityData, AccountDataRest}
import com.neurobs.ccabserver.administrator.view.CreateAccountView
import com.neurobs.js.dom.RecordTableView.CommandLinkCell
import com.neurobs.js.controller.{AdminListAdapter, AdminListController, AdminPanelController, AdminPanelDelegate}
import com.neurobs.js.view.{Form, Gui}
import com.neurobs.js.util.StringUtilities._

import scala.concurrent.{Future, Promise}
import scala.concurrent.ExecutionContext.Implicits.global

class AccountListController (gui: Gui, userData: IdentityData, dataPassword: DataPasswordCache, cache: RecordCache, addPanel: AdminPanelController => Unit)(implicit server: com.neurobs.ccab.CCABServer) extends AdminListAdapter[AccountDataRest] {

	override def title = "Accounts"

	override def itemName = "Account"

	override def columnHeaders = Seq(
		"Id",
		"Created",
		"Creator Email",
		"Organization",
		"Description",
		"",
		"",
		"",
		""
	)

	override def itemRow(a: AccountDataRest, delegate: Option[AdminPanelDelegate], controller: AdminListController[AccountDataRest]) = Seq(
		a.id.toString,
		a.createdAt,
		a.founderEmail,
		a.organization,
		a.userDescription,
		CommandLinkCell(text = "users", () => delegate.foreach(_.newPanel(UserListController(a.id, a.founderEmail, userData.legacyUserId, server, gui)))),
		CommandLinkCell(text = "studies", () => delegate.foreach(_.newPanel(StudyListController(gui, a.id, a.founderEmail, dataPassword, userData, addPanel)))),
		CommandLinkCell(text = "prop", () => delegate.foreach(_.newPanel(new AccountController(true, a.id, userData.legacyUserId, a.founderEmail, server, cache, gui)))),
		CommandLinkCell(text = "sessions", () => delegate.foreach(_.newPanel(TestSessionListController(gui, a.id, a.founderEmail))))
	)

	override val create = Some(createAccount)

	override def get(): Future[Either[String, Seq[AccountDataRest]]] = {
		val promise = Promise[Either[String, Seq[AccountDataRest]]]
		server.getAccounts()._2 map {
			case Left(error) => promise.success(Left(error.description))
			case Right(data) => promise.success(Right(data))
		}
		promise.future
	}

	private def createAccount(c: AdminListController[AccountDataRest]): Unit = {
		val form = CreateAccountView()

		def process(callback: (Option[String]) => Unit): Either[String,Form.Process] = {
			val data = CreateAccountData(
				email = form.email.value(),
				firstName =  form.firstName.value(),
				lastName =  form.lastName.value(),
				organization = form.organization.value(),
				description = form.description.value()
			)
			if (data.email.isEmpty || data.firstName.isEmpty || data.lastName.isEmpty || data.organization.isEmpty || data.description.isEmpty)
				Left("All fields are required.")
			else if (data.email != form.confirmEmail.value())
				Left("The emails don't match.")
			else
				Right({
					val call = server.createAccount(data)
					call._2 map {
						case Left(error) => callback(Some(error.description))
						case _ =>
							callback(None)
							c.getList()
					}
					call._1
				})
		}

		gui.showModalForm(form.form, process, processCancellable = true, Some(() => Unit))
	}
}

object AccountListController {
	def apply(gui: Gui, userData: IdentityData, dataPassword: DataPasswordCache, cache: RecordCache, addPanel: AdminPanelController => Unit)(implicit server: com.neurobs.ccab.CCABServer): AdminListController[AccountDataRest] = new AdminListController[AccountDataRest](new AccountListController(gui, userData, dataPassword, cache, addPanel))
}